import e from "./SchemaObjectProperties.vue.script.js";
//#region src/schema/SchemaObjectProperties.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaObjectProperties.vue.js.map